import { useState } from "react";

import {
    DialogTitle,
    Grid,
    Dialog,
    DialogContent,
    Button,
} from "@mui/material";

import {
    AccountSectionRow,
    AccountSubtitle,
    AccountInput,
} from "@/account/StyledComponents";
import { SectionEdit } from "@/account/CommonComponents";
import PaymentUpdate from "@/payment/PaymentUpdate";
import PaymentHistory from "@/payment/PaymentHistory";

export default function PaymentSection({ data, setData, setSaved }) {
    const [editing, setEditing] = useState(false);
    const [reviewing, setReviewing] = useState(false);

    const handleSuccess = (responseData) => {
        setEditing(false);
        setData({
            ...data,
            default_payment_method: responseData.default_payment_method,
        });
        setSaved(true);
    };

    const handleView = () => {
        setReviewing(true);
    };

    const handleCancel = () => {
        setEditing(false);
        setReviewing(false);
    };

    return (
        <Grid item>
            <SectionEdit
                title="Billing Details"
                editing={false}
                loading={false}
                handleEdit={() => setEditing(true)}
            />

            <AccountSectionRow>
                <AccountSubtitle>Credit Card</AccountSubtitle>
                <AccountInput>
                    <p>{data.default_payment_method}</p>
                </AccountInput>
            </AccountSectionRow>

            <AccountSectionRow>
                <AccountSubtitle>Billing History</AccountSubtitle>
                <AccountInput>
                    <Button
                        onClick={handleView}
                        variant="outlined"
                        color="info"
                    >
                        View
                    </Button>
                </AccountInput>
            </AccountSectionRow>

            <Dialog
                onClose={handleCancel}
                open={editing}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Edit Payment Details</DialogTitle>
                <DialogContent>
                    <PaymentUpdate handleSuccess={handleSuccess} />
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        color="secondary"
                        size="large"
                        fullWidth
                    >
                        Cancel
                    </Button>
                </DialogContent>
            </Dialog>

            <Dialog
                onClose={handleCancel}
                open={reviewing}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Billing History</DialogTitle>
                <DialogContent>
                    <PaymentHistory />
                    <Button
                        onClick={handleCancel}
                        variant="contained"
                        color="secondary"
                        size="large"
                        fullWidth
                    >
                        Close
                    </Button>
                </DialogContent>
            </Dialog>
        </Grid>
    );
}
